import React from 'react'
import PropTypes from 'prop-types'

function LandingPagePartnerBox({ partner, imgPath }) {
  return (
    <div className="col-6 col-md-3 u-text-center">
      <div className="partner-logo-box">
        <a href={partner.url} target="_blank">
          <img
            src={imgPath}
            alt={partner.name}
            className="partner-logo"
          />
        </a>
      </div>
    </div>
  )
}

LandingPagePartnerBox.propTypes = {
  partner: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  imgPath: PropTypes.string.isRequired,
}

export default LandingPagePartnerBox
